import React, {useContext, useEffect, useState} from 'react';
import InfoItem from "../components/Info-item/Info-item";
import {LangContext} from "../App";
import {axios} from "../axios";
import Seo from "../components/Seo/Seo";

const GuideBook = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/guide`)
            .then(res => setData(res.data.tours))

    },[lang])
    return (
        <div className='info-page'>
            <Seo pageKey="guideBook" />
            <div className="center-wrapper">
                <div className="info-list">
                    {data.map(e => <InfoItem path='guide' key={e.id} tour={e}/>)}
                </div>
            </div>
        </div>
    );
};

export default GuideBook;